import { distanceBetweenPoints } from "./distanceBetweenPoints";

export function processMouseOverAndMouseMoveDiagPath(event, car, specificCarHistoryData, polyLinesData, setHoverStateHistory) {
    let blue = "#0000FF";
    let MARKER_Z_INDEX_DELTA = 100;

    var hoveredOverLocation = null;
    let NumOfSelectedCarsForHistory = specificCarHistoryData
      ? Object.keys(specificCarHistoryData).length
      : 0;
    polyLinesData.forEach((path) => {
      if (path.car === car) {
        if (NumOfSelectedCarsForHistory && NumOfSelectedCarsForHistory > 1) {
          if (!path.isHoveredOver) {
            path.isHoveredOver = true;
            var hoverStrokeColor = blue;
            path?.setOptions({
              strokeColor: hoverStrokeColor,
              strokeWeight: 5,
              strokeOpacity: 1,
              zIndex: path.zIndexUsed + MARKER_Z_INDEX_DELTA,
            });
          }
        }
        let paths = path.getPath().getArray();
        let distance = 100; // 100 KM
        paths.forEach(function (location) {
          var newDistance = distanceBetweenPoints(location, event.latLng);
          if (newDistance < distance) {
            distance = newDistance;
            hoveredOverLocation = location;
          }
        });
      }
    });
    if (hoveredOverLocation) {
      var offset = {
        x: 20,
        y: 20,
      };
      let obj = {
        state: true,
        position: "fixed",
        car: car.toString(),
        TimeStamp: hoveredOverLocation.TimeStamp,
        top: event.domEvent.clientY + window.scrollY + offset.y + "px",
        left: event.domEvent.clientX + window.scrollX + offset.x + "px",
      };
      setHoverStateHistory(obj);
    }
  }